export default function ({ app, store, redirect }) {
  if (store?.state?.customer?.shopifyAccess?.accessToken) {
    const redirectPath =
      app.i18n.locale === 'en-us'
        ? '/en-us/account'
        : app.localePath('/account')
    return redirect(redirectPath)
  }
}
